import React, { useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  FlatList,
} from "react-native";
import { timeCalulate } from "../../component/utils";

export default function tebleuserrank({ navigation, data }) {
  return (
    <View style={[styles.back, { width: "100%" }]}>
      <View style={styles.head}>
        <View style={[styles.viewhead, { width: "60%" }]}>
          <Text style={[styles.texthead, { alignSelf: "center" }]}>User</Text>
        </View>

        <View style={[styles.viewhead, { width: "20%", alignItems: "center" }]}>
          <Text style={styles.texthead}>Distance</Text>
        </View>
        <View style={[styles.viewhead, { width: "20%", alignItems: "center" }]}>
          <Text style={styles.texthead}>Time</Text>
        </View>
      </View>

      <FlatList
        data={data}
        scrollEnabled
        contentContainerStyle={{ backgroundColor: "#393939" }}
        renderItem={({ index, item }) => {
          const distance = item.last_distance ?? 0;
          const runningTime = item.running_Time ?? 0;
          return (
            <View style={{ backgroundColor: "#393939" }}>
              {item.user_accounts != undefined && (
                <View
                  style={[
                    styles.viewmain,
                    {
                      width: "100%",
                      backgroundColor:
                        index == 0
                          ? "#f3be0e"
                          : index == 1
                            ? "#c2c0c1"
                            : index == 2
                              ? "#db761a"
                              : "#FFFFFF",
                      alignItems: "center",
                      marginTop: 4,
                      marginBottom: index == data?.length - 1 ? 10 : 0,
                    },
                  ]}
                >
                  <TouchableOpacity
                    style={[
                      styles.viewdetail,
                      {
                        width: "60%",
                        alignItems: "center",
                        paddingBottom: 5,
                        paddingLeft: 20,
                      },
                    ]}
                  >
                    <Image
                      source={{
                        uri: item.user_accounts.image_Profile,
                      }}
                      style={index == 0 ? styles.img1 : styles.img}
                    />
                    <View>
                      {item.user_accounts.name == "" ||
                      item.user_accounts.name == null ? (
                        <Text
                          style={
                            index == 0 ? styles.textdeil : styles?.textdeil1
                          }
                        >
                          {index + 1}. {item.user_accounts.username}
                        </Text>
                      ) : (
                        <Text
                          style={
                            index == 0 ? styles.textdeil : styles?.textdeil1
                          }
                        >
                          {index + 1}. {item.user_accounts.name}
                        </Text>
                      )}
                    </View>
                  </TouchableOpacity>

                  <View
                    style={[
                      styles.viewdetail,
                      { width: "20%", justifyContent: "center" },
                    ]}
                  >
                    <Text
                      style={index == 0 ? styles.textdate : styles.textdate1}
                    >
                      {(distance / 1000).toFixed(2)} กม.
                    </Text>
                  </View>
                  <View
                    style={[
                      styles.viewdetail,
                      { width: "20%", justifyContent: "center" },
                    ]}
                  >
                    <Text
                      style={index == 0 ? styles.textdate : styles.textdate1}
                    >
                      {timeCalulate(runningTime)}
                    </Text>
                  </View>
                </View>
              )}
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    // maxWidth: 1240,
    alignSelf: "center",
    height: "100%",
    borderWidth: 0.5,
    borderColor: "#00000015",
    backgroundColor: "#393939",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.2,
    shadowRadius: 4,
    elevation: 5,
    overflow: "hidden",
  },
  head: {
    width: "100%",
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    paddingVertical: 10,
    paddingHorizontal: 15,
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#D8DCE6",
  },
  viewhead: {
    paddingLeft: 10,
    justifyContent: "center",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    fontWeight: "600",
    color: "#172B4D",
    letterSpacing: 0.3,
  },
  viewdetail: {
    flexDirection: "row",
    alignItems: "center",
  },
  img: {
    width: 36,
    height: 36,
    borderRadius: 18,
    borderWidth: 1.5,
    borderColor: "#FFFFFF80",
    backgroundColor: "#555",
  },
  img1: {
    width: 48,
    height: 48,
    borderRadius: 24,
    borderWidth: 2,
    borderColor: "#FFFFFF",
    backgroundColor: "#555",
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    fontWeight: "700",
    color: "#172B4D",
    marginLeft: 12,
    flexShrink: 1,
  },
  textdeil1: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#393939",
    marginLeft: 12,
    flexShrink: 1,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#555",
    marginLeft: 12,
  },
  viewmain: {
    flexDirection: "row",
    paddingHorizontal: 10,
    paddingVertical: 8,
    alignItems: "center",
    borderBottomWidth: 0.5,
    borderBottomColor: "#00000015",
    minHeight: 56,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    fontWeight: "600",
    color: "#172B4D",
    alignSelf: "center",
    textAlign: "center",
  },
  textdate1: {
    fontFamily: "Prompt-Regular",
    fontSize: 13,
    color: "#172B4D",
    alignSelf: "center",
    textAlign: "center",
  },
  viewatc: {
    width: "18%",
    height: 36,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 34,
    height: 34,
    borderRadius: 17,
    borderWidth: 1,
    borderColor: "#8898AA",
    justifyContent: "center",
    alignItems: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 14,
    color: "#7764E4",
    alignSelf: "center",
  },
});
